// light mode color

export const lightTheme = {
  body: "#F4F6F9",
  text: "#363537",
  greytext: "#777a86",
  inputField: "#eef3f7",
  toggleBorder: "#FFF",
  background: "#363537",
  backgroundSidebar: "#fff",
  shadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;",
  boxShadow:
    "rgba(255, 255, 255, 0.16) 0px 3px 3px,rgba(179, 179, 179, 0.23) 0px 3px 10px;",
  bgPrimary: "#0b618d",
  box: "#fff",
  backgroundActive: "#E2EDFB",
  border: "#c8cccf",
  chatRight: "#f1faff",
  chatLeft: "#f8f5ff",
  attach: "#b8b8b8",
  borderLight: "#CED4DA",
};

// dark mode color

export const darkTheme = {
  body: "#0e1621",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  greytext: "#dfdfdf",
  inputField: "#232932",
  background: "#999",
  // backgroundSidebar: "#0e1621",
  backgroundSidebar: "#17212b",
  shadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
  bgPrimary: "#0b618d",
  box: "#17212b",
  backgroundActive: "#555555",
  border: "#0e1621",
  chatRight: "#708f9f",
  chatLeft: "#aa8fb7",
  attach: "#b6b6b6",
  borderLight: "#fff",
};
